<script>
import { mapGetters, mapActions } from "vuex";

//import appStatuses from "../../service/app-statuses.js";

import AdminOlimpiadaShow from "~/src/components/AdminOlimpiadaShow.vue";
import AppConfirm from "~/src/components/modals/app-confirm.vue";

export default {
  components: {
    AdminOlimpiadaShow,
    AppConfirm,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
    },

    tab: "Personal info",

    loading: false,

    deleteDialog: false,

    isContract: false,

    isInvoice: false,

    pdfData: null,
  }),

  computed: {
    ...mapGetters("admin-olimpiada2024s", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",

    isVerifierAdmin: (vm) => vm.user.role == "ADMIN_VERIFIER",

    /*    applicationStatus() {
      const status =
        appStatuses.find((x) => x.id == this.application.status) || {};

      return {
        name: status[`name-${this.$i18n.locale}`],
        color: color(status.id),
      };

      function color(statusName) {
        switch (statusName) {
          case "ACCEPTED":
            return "#8E44AD";
          case "PASSED":
            return "#26d316";
          case "REJECTED":
            return "#e62d2d";
          case "SUBMITTED":
            return "#F8D811";
          case "FAILED":
            return "#Fb1e06";
          case "EXAMINED":
            return "#1A0959";
          default:
            return null;
        }
      }
    },*/
  },

  created() {
    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({ id }).then((status) => {
        if (!status) {
          this.$router.replace("/admin/");
          return;
        }
      });
    }
  },

  methods: {
    ...mapActions("admin-olimpiada2024s", ["INIT_BY_ID", "DELETE_APPLICATION"]),

    ...mapActions("admin-olimpiada2024", ["INIT_APPLICATION"]),

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/olimpiada2024");
        }
      });
    },
  },
};
</script>

<template>
  <div class="pb-5">
    <app-confirm
      v-model="deleteDialog"
      :text="$t('Do you really want to delete?')"
      @accept="onDelete"
    />

    <v-container class="-wrap">
      <div class="pa-5">
        <div header>
          <div class="title pb-2 text-center accent--text tab-title" v-text="$t(tab)" />

          <div
            v-if="isSupperAdmin || isVerifierAdmin"
            class="title-actions pb-5"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  elevation="0"
                  color="accent"
                  @click="tab = tabs.personal"
                  :outlined="tab != tabs.personal"
                  class="px-0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-badge-account-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Personal info") }}</span>
            </v-tooltip>

            <!--            <v-tooltip
              v-if="
                !application.paid && application.typeAbiturient == 'ABITURIENT'
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  @click="onEdit"
                  :outlined="tab != tabs.edit"
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>-->

            <!--            <v-tooltip v-if="isSupperAdmin" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  :outlined="tab != tabs.history"
                  v-bind="attrs"
                  v-on="on"
                  @click="onHistory"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-history </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Application history") }}</span>
            </v-tooltip>-->
            <v-tooltip v-if="isSupperAdmin" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="red"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="deleteDialog = true"
                >
                  <v-icon> mdi-delete-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </div>

          <div class="position-relative">
            <v-progress-linear
              top
              absolute
              :active="loading"
              indeterminate
              posi
            />
          </div>
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </div>

        <div body class="pt-5">
          <admin-olimpiada-show v-if="tab == tabs.personal" />
          <!--          <admin-app-show-edit v-else-if="tab == tabs.edit" />
          <admin-app-history v-else-if="tab == tabs.history" />-->
        </div>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.-status-wrap {
  display: flex;
  justify-content: center;

  .-status {
    padding: 8px 5px;
    border-radius: 10px;
    max-width: 320px;
    width: 100%;
    text-align: center;
    cursor: default;

    color: white;
  }
}

.-wrap {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;

  .title-actions {
    .v-btn {
      min-width: 44px;
    }
  }
}
</style>
